<h3 mat-dialog-title>{{title}}</h3>
<mat-dialog-content>
  <form [formGroup]="dialogForm" class="pt-1">
    <mat-form-field  appearance="outline" class="w-100">
      <mat-label>New Password</mat-label>
      <input matInput placeholder="Password" formControlName="password" type="password" minlength="6" required [type]="hide ? 'password' : 'text'" autocomplete="new-password">
      @if (dialogForm.controls.password.errors?.required) {
        <mat-error>Password is required</mat-error>
      }
      @if (dialogForm.controls.password.errors?.pattern) {
        <mat-error>Password does not meet the password rules</mat-error>
      }
      <button mat-icon-button matIconSuffix (click)="hide = !hide" type="button" class="text-muted">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field  appearance="outline" class="w-100">
      <mat-label>Confirm Password</mat-label>
      <input matInput placeholder="Confirm Password" formControlName="confirmPassword" type="password" required [type]="hide ? 'password' : 'text'" autocomplete="new-password">
      @if (dialogForm.controls.confirmPassword.errors?.required) {
        <mat-error>Confirm Password is required</mat-error>
      }
      @if (dialogForm.controls.confirmPassword.hasError('mismatchedPasswords')) {
        <mat-error>Passwords do not match</mat-error>
      }
      <button mat-icon-button matIconSuffix (click)="hide = !hide" type="button" class="text-muted">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
    <small class="flex-row space-between items-start mx-3">
      <div class="flex-col">
        <ul>
          <li>One uppercase character</li>
          <li>One lowercase character</li>
          <li>One special character ({{passwordAllowedSpecialCharacters}})</li>
        </ul>
      </div>
      <div></div>
      <div class="flex-col">
        <ul>
          <li>8 character minimum</li>
          <li>One digit</li>
        </ul>
      </div>
    </small>

  </form>
</mat-dialog-content>
<mat-dialog-actions >
  <div class="w-100 flex-row justify-end items-center mt-3 p-2">
    <a mat-button color="primary" class="dialog-btn mr-5" (click)="onCancelClick()"><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button color="primary" class="dialog-btn" (click)="onConfirmClick()" [disabled]='!dialogForm.valid'><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>


